// extracted by mini-css-extract-plugin
export default {"dockableModal":"DockableModal_dockableModal__6zM97"};